export default class ConfigService {
    static __config = null; 
    static __idConfig = null;

    static async getConfig(){
        if(ConfigService.__config == null){
            ConfigService.__config = (await window.fetch("api/configuration/default")).json();
        }      
        return ConfigService.__config;
    }

    static async getIdentityConfig() {
        if (ConfigService.__idConfig == null) {
            var config = await ConfigService.getConfig();
            // override properties from server (i.e. appropriate appsettings)
            ConfigService.__idConfig = config.identityConfig;
        }
        return ConfigService.__idConfig;
    }
}